import { Component } from 'preact';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: props.isOpen,
    };
  }

  onOpen = () => {
    if (!this.state.isOpen) {
      this.setState({
        isOpen: true,
      });
    }
  };

  onClose = () => {
    if (this.state.isOpen) {
      this.setState({
        isOpen: false,
      });
    }
  };

  listenKeyboard = (event) => {
    if (event.key === `Escape` || event.keyCode === 27) {
      this.onClose();
    }
  };

  componentDidMount = () => {
    window.addEventListener(`keydown`, this.listenKeyboard.bind(this), true);
  };

  componentWillUnmount = () => {
    window.removeEventListener(`keydown`, this.listenKeyboard.bind(this), true);
  };

  onDialogClick = (event) => {
    event.stopPropagation();
  };

  render({ children }, { isOpen }) {
    return children({
      isOpen,
      onOpen: this.onOpen,
      onClose: this.onClose,
      onDialogClick: this.onDialogClick,
      CloseModal: (props) => <button type="button" onClick={this.onClose} {...props} />,
      ModalContent: ({ className, ...props }) => (
        <section
          onclick={this.onDialogClick}
          {...props}
          class={`${className ? `${className} ` : ``}dialog`}
        />
      ),
      ModalOverlay: ({ className, ...props }) => (
        <aside
          onclick={this.onClose}
          {...props}
          class={`${className ? `${className} ` : ``}modal ${isOpen ? `open` : ``}`}
        />
      ),
      OpenModal: (props) => <button type="button" onClick={this.onOpen} {...props} />,
    });
  }
}

export default Modal;
